import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import InputField from '../components/ui/InputField';
import TextAreaField from '../components/ui/TextAreaField';
import Button from '../components/ui/Button';

const OfisGiderReportForm = ({ onDataChange }) => {
  const { t } = useTranslation();
  const [projectInfo, setProjectInfo] = useState({
    projectName: '',
    department: '',
    reportPeriod: new Date().toISOString().slice(0, 7)
  });

  const [expenses, setExpenses] = useState([
    { expenseItem: '', category: 'Office Supplies', quantity: 1, unitPrice: 0, total: 0 }
  ]);

  const [notes, setNotes] = useState('');

  useEffect(() => {
    const grandTotal = expenses.reduce((sum, item) => sum + item.total, 0);
    onDataChange({
      ...projectInfo,
      expenses,
      notes,
      grandTotal,
      date: new Date().toLocaleDateString()
    });
  }, [projectInfo, expenses, notes, onDataChange]);

  const handleExpenseChange = (index, field, value) => {
    const newExpenses = [...expenses];
    newExpenses[index][field] = value;
    if (field === 'quantity' || field === 'unitPrice') {
      newExpenses[index].total = newExpenses[index].quantity * newExpenses[index].unitPrice;
    }
    setExpenses(newExpenses);
  };

  const grandTotal = expenses.reduce((sum, item) => sum + item.total, 0);

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl p-6 lg:p-8 border border-gray-200 dark:border-gray-700 shadow-sm space-y-8">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <InputField label="Project Name" name="projectName" value={projectInfo.projectName} onChange={(e) => setProjectInfo({ ...projectInfo, projectName: e.target.value })} placeholder="e.g., Office Renovation" required />
        <InputField label="Department" name="department" value={projectInfo.department} onChange={(e) => setProjectInfo({ ...projectInfo, department: e.target.value })} placeholder="Department name" />
        <InputField label="Report Period" name="reportPeriod" type="month" value={projectInfo.reportPeriod} onChange={(e) => setProjectInfo({ ...projectInfo, reportPeriod: e.target.value })} />
      </div>

      <div>
        <h3 className="text-xl font-bold text-[#111418] dark:text-white mb-4">Office Expenses</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead className="border-b border-gray-200 dark:border-gray-700">
              <tr>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400">Expense Item</th>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400">Category</th>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400">Qty</th>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400">Unit Price</th>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400 text-right">Total</th>
                <th className="p-3 w-12"></th>
              </tr>
            </thead>
            <tbody>
              {expenses.map((expense, index) => (
                <tr key={index} className="border-b border-gray-200 dark:border-gray-700">
                  <td className="p-2"><input className="form-input w-full bg-transparent border-0 focus:ring-0 p-2" type="text" value={expense.expenseItem} onChange={(e) => handleExpenseChange(index, 'expenseItem', e.target.value)} placeholder="e.g., Stationery, Furniture" /></td>
                  <td className="p-2">
                    <select className="form-select w-full bg-transparent border-0 focus:ring-0 p-2" value={expense.category} onChange={(e) => handleExpenseChange(index, 'category', e.target.value)}>
                      <option>Office Supplies</option>
                      <option>Furniture</option>
                      <option>Equipment</option>
                      <option>Utilities</option>
                      <option>Maintenance</option>
                      <option>Other</option>
                    </select>
                  </td>
                  <td className="p-2"><input className="form-input w-20 bg-transparent border-0 focus:ring-0 p-2 text-center" type="number" min="1" value={expense.quantity} onChange={(e) => handleExpenseChange(index, 'quantity', parseFloat(e.target.value) || 0)} /></td>
                  <td className="p-2"><input className="form-input w-28 bg-transparent border-0 focus:ring-0 p-2 text-right" type="number" min="0" step="0.01" value={expense.unitPrice} onChange={(e) => handleExpenseChange(index, 'unitPrice', parseFloat(e.target.value) || 0)} /></td>
                  <td className="p-2 text-right font-medium text-[#111418] dark:text-gray-100">${expense.total.toFixed(2)}</td>
                  <td className="p-2 text-center"><button onClick={() => setExpenses(expenses.filter((_, i) => i !== index))} className="text-gray-400 hover:text-red-500" disabled={expenses.length === 1}><span className="material-symbols-outlined text-xl">delete</span></button></td>
                </tr>
              ))}
            </tbody>
          </table>
          <Button onClick={() => setExpenses([...expenses, { expenseItem: '', category: 'Office Supplies', quantity: 1, unitPrice: 0, total: 0 }])} variant="ghost" icon="add_circle" className="mt-4">{t('form.addRow')}</Button>
        </div>
      </div>

      <div className="flex justify-end">
        <div className="w-full max-w-sm space-y-3 bg-gray-50 dark:bg-gray-900 p-4 rounded-lg">
          <div className="flex justify-between items-center pt-3"><span className="text-lg font-bold text-[#111418] dark:text-gray-100">{t('form.grandTotal')}</span><span className="text-lg font-bold text-primary">${grandTotal.toFixed(2)}</span></div>
        </div>
      </div>

      <TextAreaField label={t('form.notes')} value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Project notes, budget details..." rows={3} />
    </div>
  );
};

export default OfisGiderReportForm;
